module.exports = __webpack_public_path__ + "static/media/socialTwitter.a0bc6f46.svg";